module.exports = __webpack_public_path__ + "static/media/mickael-dantas.c22c3c5a.png";